var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.bubble = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    var debugWidget = widget.data('id') === '7cca20dc-f60a-486b-8624-9d142552da87';
    
    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var container = $('<div class="bubble">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
        
        if (data.length > 0) {
            var keys = MDB.Charts.getDataKeys(data[0])
                , xField = keys[0]
                , yField = keys[1]
                , sizeField = keys[2]
                , categoryField = keys[3]
                , typeField = keys[4]
                , groupingField = typeField || categoryField
                , titleHelper = externalTitleHelper(chart)
                , allSizesAreDefault = false;
            
            metadata.KendoConfig.seriesColors = getPalette(groupingField);
            var colorGenerator = createColorGenerator();
            
            if(metadata.KendoConfig && metadata.KendoConfig.seriesDefaults && metadata.KendoConfig.seriesDefaults._defaultSize){
                var defaultSizedData = data.filter(function(d){
                    return d[sizeField] === undefined || d[sizeField] === null
                });
                
                allSizesAreDefault = defaultSizedData.length === data.length;
                
                //Set the provided defaultSize for all items with a size of undefined/NULL
                defaultSizedData.forEach(function(d){ 
                    d[sizeField] = metadata.KendoConfig.seriesDefaults._defaultSize; 
                });
            }

            //This needs to happen after defaultSizes have been assigned
            //The decision path includes logic based on these
            var minSize = getMinSize()
                , maxSize = getMaxSize();
            
            var kendoConfig = {
                seriesDefaults: {
                    type: 'bubble'
                },
                series: getGroupedSeries(groupingField),
                legend: {
                    visible: true,
                    position: "right"
                }
            };
            
            //Legacy?
            if(metadata.KendoConfig && metadata.KendoConfig.ColumnTypes){
                var columnTypes = metadata.KendoConfig.ColumnTypes;

                if (columnTypes[0] === 'number') {
                    kendoConfig.xAxis.labels.format = '{0:N0}';
                }
                if (columnTypes[1] === 'number') {
                    kendoConfig.yAxis.labels.format = '{0:N0}';
                }
            }
            
            //We'll extend the series manually later on, delete them from the config
            var metaSeries = metadata.KendoConfig.series;
            delete metadata.KendoConfig.series;
            
            $.extend(true, kendoConfig, metadata.KendoConfig);
            
            var formatableValues = MDB.Charts.getAggregatedFormatableValues(data, keys);
            
            kendoConfig.series.forEach(function(series){
                $.extend(true, series, metaSeries);
                
                MDB.Charts.setLabelFormat(series, kendoConfig.seriesDefaults, formatableValues, sizeField, 'tooltip', function(targetLabels, template){
                    template = template || '# if(!/^\\s+$/.test(category)) { # #= category #: # }#  #= value.size #';
                    return template;
                });
            });

            MDB.Charts.initializeLegendClickHandler(kendoConfig);
            
            MDB.Charts.setKendoClickHandler(kendoConfig, widget, function(data){
                //Datapoints are passed in as is
                //So simply returning the input should be enough
                return data.dataItem;
            });
            
            if(kendoConfig.yAxis.title && kendoConfig.yAxis.title._renderOutsideChart){
                titleHelper.appendTitle(kendoConfig.yAxis.title, 'y-axis');
            }

            if(kendoConfig.xAxis.title && kendoConfig.xAxis.title._renderOutsideChart){
                titleHelper.appendTitle(kendoConfig.xAxis.title, 'x-axis');
            }
            
            chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).prepend(container);
            container.kendoChart(kendoConfig);
        }
        
        function externalTitleHelper(chart){
            //Force hiding of overflow; left positioned horizontal labels can exceed the container bounds
            chart.css({'overflow': 'hidden'});
            
            var verticalContainerBase = $('<div />').css({
                'display': 'block',
                'width': '100%',
                'height': '5%',
                'position': 'relative',
                'text-align': 'center'
            });
            
            var horizontalContainerBase = $('<div />').css({
                'display': 'block',
                'position': 'relative',
                'bottom': '40%'
            });
            
            var positionConfig = {
                top: {
                    base: verticalContainerBase,
                    style: {
                        'bottom': '90%'
                    }
                },
                bottom: {
                    base: verticalContainerBase,
                    style: {
                        'top': '5%'
                    }
                },
                left: {
                    base: horizontalContainerBase,
                    style: {
                        'right': '3%'
                    }
                },
                right: {
                    base: horizontalContainerBase,
                    style: {
                        'left': '91%'
                    }
                }
            };
            
            var containerCache = {};
            
            return {
                appendTitle: function(opts, name){
                    //Ensure title is not rendered by kendo
                    opts.visible = false;
                    
                    //Clear previous element
                    if(containerCache[name]){
                        containerCache[name].remove();
                        containerCache[name] = undefined;
                    }
                    
                    var config = positionConfig[opts.position] || positionConfig['bottom'];
                    
                    return containerCache[name] = this._appendTitle(
                        opts,
                        config.base,
                        config.style
                    );
                },
                
                _appendTitle: function(opts, containerBase, containerStyle){
                    var labelStyle = {};
                    if(opts.rotation){
                        labelStyle.transform = 'rotate(' + opts.rotation + 'deg)';
                    }
                    
                    //Ensure we always have a fresh container before doing anything funky with it
                    return containerBase.clone()
                        .css(containerStyle)
                        .append($('<label />').css(labelStyle).text(opts.text))
                        .appendTo(chart);
                }
            }
        }
        
        function getPalette(groupingField){
            var hasPalette = metadata.KendoConfig.seriesColors && metadata.KendoConfig.seriesColors.length;

            if(hasPalette){
                return metadata.KendoConfig.seriesColors;
            }

            var chartColorGenerator = MDB.Charts.createColorGenerator();

            //Base palette on groupingField, as this is displayed in the legend
            return _.map(_.uniqBy(data, groupingField), function(dataItem){
                return chartColorGenerator(dataItem[groupingField]);
            });
        }
        
        function createColorGenerator(){
            var currentIndex = 0
                , palette = metadata.KendoConfig.seriesColors
                , maxIndex = palette.length;
            
            var colorMapping = {};
            
            return function(name){
                if(colorMapping[name]){
                    return colorMapping[name];
                }
                
                if(currentIndex >= maxIndex){
                    currentIndex = 0;
                }
                
                return colorMapping[name] = palette[currentIndex++];
            }
        }
        
        function getGroupedSeries(groupingField){
            //https://www.telerik.com/forums/how-to-set-legend-color-in-bubble-chart
            //Each type needs its own series

            var dataPerGroup = _.groupBy(data, groupingField);
            
            return _.reduce(Object.keys(dataPerGroup), function(series, groupName){
                var seriesData = dataPerGroup[groupName].slice();
                series = series || [];
                
                //Kendo determines unit size per series
                //Ensure every series contains an both the min/max item
                seriesData.push(createMinDataItem());
                seriesData.push(createMaxDataItem());
                
                var color = colorGenerator(groupName);
                
                series.push({
                    data: seriesData,
                    name: groupName,
                    
                    //Highlight -> border is shown when hovering over the series name in the legend
                    highlight: {
                        border: {
                            width: function(args){
                                //Min/Max placeholder border should not be displayed
                                return args.dataItem.isMinMax ? 0 : 1;
                            }
                        }
                    },
                    xField: xField,
                    yField: yField,
                    sizeField: sizeField,
                    categoryField: categoryField,
                    color: function(args){
                        //Min/Max placeholder values should not be drawn
                        return args.dataItem.isMinMax ? '' : color;
                    }
                });

                return series;
            }, []);
        }
        
        function getMaxSize(){
            var seriesDefaults = metadata.KendoConfig.seriesDefaults;
            var seriesMaxSize = _.maxBy(data, sizeField)[sizeField];
            
            if(seriesDefaults && seriesDefaults._scaleViaMaxSize){
                //Certain widgets only want to scale via max size when all values are NULL
                if(!seriesDefaults._scaleViaMaxSizeOnlyWhenAllSizesDefault || allSizesAreDefault){
                    seriesMaxSize = seriesDefaults.maxSize;
                }
            }
            
            return seriesMaxSize;
        }
        
        function getMinSize(){
            var seriesDefaults = metadata.KendoConfig.seriesDefaults;
            var seriesMinSize = _.minBy(data, sizeField)[sizeField];
            
            if(seriesDefaults && seriesDefaults._scaleViaMinSize){
                //Certain widgets only want to scale via max size when all values are NULL
                if(!seriesDefaults._scaleViaMinSizeOnlyWhenAllSizesDefault || allSizesAreDefault){
                    seriesMinSize = seriesDefaults.minSize;
                }
            }

            return seriesMinSize;
        }
        
        function createMinDataItem(){
            var obj = createDataItem(0, 0, minSize);
            obj.isMinMax = true;
            
            return obj;
        }
        
        function createMaxDataItem(){
            var obj = createDataItem(0, 0, maxSize);
            obj.isMinMax = true;
            
            return obj;
        }
        
        function createDataItem(x, y, size){
            var obj = {};
            
            obj[xField] = x;
            obj[yField] = y;
            obj[sizeField] = size;
            return obj;
        }
    }, 0);
};